import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../api";
import { t } from "../i18n";

export default function ClinicDoctors({ lang }) {
  const { token } = useAuth();
  const [doctors, setDoctors] = useState([]);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");
  const [loading, setLoading] = useState(false);

  const load = () =>
    api("/api/clinic/doctors", { token })
      .then((d) => setDoctors(d.doctors || []))
      .catch((e) => setErr(e.message));

  useEffect(() => {
    let live = true;
    api("/api/clinic/doctors", { token })
      .then((d) => live && setDoctors(d.doctors || []))
      .catch((e) => live && setErr(e.message));
    return () => {
      live = false;
    };
  }, [token]);

  const submit = async () => {
    setErr("");
    setOk("");
    if (password !== confirm) {
      setErr(t(lang, "passwordsMismatch"));
      return;
    }
    setLoading(true);
    try {
      await api("/api/clinic/doctors", {
        method: "POST",
        token,
        body: { name, phone, password, language: lang },
      });
      setName("");
      setPhone("");
      setPassword("");
      setConfirm("");
      setOk(t(lang, "doctorAdded"));
      await load();
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tt-page">
      <h2>{t(lang, "clinicDoctors")}</h2>
      <p className="tt-muted">{t(lang, "clinicDoctorsHint")}</p>
      {err && <p className="tt-err">{err}</p>}
      {ok && <p className="tt-ok">{ok}</p>}

      <div className="tt-list">
        {doctors.map((d) => (
          <div key={d.id} className="tt-rx">
            <strong>{d.name || t(lang, "doctorName")}</strong>
            <span>{d.phone}</span>
          </div>
        ))}
      </div>
      {!doctors.length && <p className="tt-muted">{t(lang, "noDoctorsYet")}</p>}

      <h3>{t(lang, "addDoctor")}</h3>
      <input
        placeholder={t(lang, "doctorName")}
        value={name}
        onChange={(e) => setName(e.target.value)}
        disabled={loading}
      />
      <input
        type="tel"
        inputMode="numeric"
        placeholder={t(lang, "doctorPhone")}
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        disabled={loading}
      />
      <input
        type="password"
        placeholder={t(lang, "doctorPassword")}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        disabled={loading}
      />
      <input
        type="password"
        placeholder={t(lang, "confirmPassword")}
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        disabled={loading}
        onKeyDown={(e) => e.key === "Enter" && submit()}
      />
      <p className="tt-hint">{t(lang, "passwordHint")}</p>
      <button className="tt-btn" onClick={submit} disabled={loading}>
        {loading ? "…" : t(lang, "addDoctor")}
      </button>
      <p className="tt-foot">{t(lang, "neverStop")}</p>
    </div>
  );
}
